/* global $ */
import React, { Component } from 'react';
import { Button, Form, Dropdown } from 'semantic-ui-react';
import {MapComponent} from './Map';

export class DetailsState extends Component {
    constructor() {
        super();
        this.nextStep = this.nextStep.bind(this);
        this.state = {
            businessNameValue: undefined,
            businessTypeValue: undefined
        }
    }

    componentDidMount() {
        this.setState({
            businessNameValue: this.props.fieldValues.businessName,
            businessTypeValue: this.props.fieldValues.businessType
        });
        this.props.setSaved(false);
        this.props.setSkipped(false);
        this.validateForm();
    }

    componentDidUpdate() {
        this.validateForm();
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            businessNameValue: nextProps.fieldValues.businessName,
            businessTypeValue: nextProps.fieldValues.businessType
        });
    }

    setBusinessName(e) {
        this.setState({
            businessNameValue: e.target.value
        })
    }

    setBusinessType(e, data) {
        this.setState({
            businessTypeValue: data.value
        })
    }

    submitDetailsStateForm() {
        $('#detailsStateSubmit').click();
    }

    validateForm() {

        var self = this;

        $('#details')
            .form({
                fields: {
                    businessName: {
                        rules: [
                            {
                                type   : 'maxLength[32]',
                                prompt : this.props.showMessage("message_5_09")
                            },
                            {
                                type   : 'empty',
                                prompt : this.props.showMessage("message_5_08")
                            }
                        ]
                    }
                },
                onSuccess: function (e) {
                    self.nextStep(e)
                },
                onFailure: function (e) {
                    if ($('#businessTypeValueContainer').hasClass('error')) {
                        $('#businessType').addClass('error')
                    }
                }
            })
        ;
    }

    render() {
        var stateOptions = [
            { value: 'pubs', text: this.props.showMessage('message_5_11') },
            { value: 'restaurant', text: this.props.showMessage('message_5_12') },
            { value: 'bookshop', text: this.props.showMessage('message_5_13') },
            { value: 'clothesStore', text: this.props.showMessage('message_5_14') },
            { value: 'shoeShop', text: this.props.showMessage('message_5_15') },
            { value: 'store', text: this.props.showMessage('message_5_16') },
            { value: 'coffeeshop', text: this.props.showMessage('message_5_17') },
            { value: 'supermarket', text: this.props.showMessage('message_5_18') },
            { value: 'gardenCentre', text: this.props.showMessage('message_5_19') },
            { value: 'garage', text: this.props.showMessage('message_5_20') },
            { value: 'pharmacy', text: this.props.showMessage('message_5_21') },
            { value: 'hotel', text: this.props.showMessage('message_5_22') },
            { value: 'generalPractice', text: this.props.showMessage('message_5_24') },
            { value: 'dentistPractice', text: this.props.showMessage('message_5_25') },
            { value: 'hairdresser', text: this.props.showMessage('message_5_26') },
            { value: 'beautySalon', text: this.props.showMessage('message_5_27') },
            { value: 'other', text: this.props.showMessage('message_5_28'), selected : 'true' }];

        var accountId = this.props.accountId;
        var token = this.props.accessToken;
        // Get values from session if we have refreshed the page, because we lost them
        if (accountId == undefined) {
            accountId = sessionStorage.getItem('accountId');
            token = sessionStorage.getItem('token');
        }

        return (
            <div className="outerContent">
                <div className="innerContent">
                    <h2 className="purple title">{this.props.showMessage('message_5_01')}<br/>{this.props.showMessage('message_5_02')}</h2>
                    <div className="flexbox">
                        <div className="map">
                            <MapComponent accessToken={token}
                                          accountId={accountId} />
                        </div>
                        <Form id="details">
                            <Form.Field>
                                <input type="text" placeholder={this.props.showMessage('message_5_03')} name="businessName" ref="businessName" onChange={this.setBusinessName.bind(this)} value={this.state.businessNameValue} />
                            </Form.Field>
                            <Form.Field id="businessType">
                                <Dropdown value={this.state.businessTypeValue} className="ui compact selection dropdown"
                                          onChange={this.setBusinessType.bind(this)}
                                          options={stateOptions}
                                          defaultValue={this.props.showMessage('message_5_28')}
                                          placeholder={this.props.showMessage('message_5_28')}
                                />
                            </Form.Field>

                            <div className="hidden">
                                <Button id="detailsStateSubmit"></Button>
                            </div>

                            <div className="ui error message"></div>
                        </Form>
                    </div>
                </div>
                <div className="footer">
                    <span id="detailsFooterText">
                        {this.props.showMessage('message_5_05')}
                    </span>
                    <div className="formButtons">
                        <Button className="secondary" onClick={this.props.skipSettings}>{this.props.showMessage('message_5_06')}</Button>
                        <Button className="primary" onClick={this.submitDetailsStateForm}>{this.props.showMessage('message_5_07')} ></Button>
                    </div>
                </div>
            </div>
        )
    };

    nextStep(e) {
        e.preventDefault();

        // Get values via this.refs
        var data = {
            businessName: this.state.businessNameValue,
            businessType: this.state.businessTypeValue
        };

        this.props.saveValues(data);
        this.props.nextStep();
    };
}



// WEBPACK FOOTER //
// ./src/components/DetailsState.jsx